import { render, staticRenderFns } from "./wireTransfer.vue?vue&type=template&id=fcf16976&"
import script from "./wireTransfer.vue?vue&type=script&lang=js&"
export * from "./wireTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports